import React from 'react'

import PropTypes from 'prop-types'
import LPComparisonRow from './LPComparisonRow'
import { entryOptions, defaultIcons } from '../builderUtils/constants'
import {
  ChartSection,
  Header,
  Headline,
  Subheadline,
  ComparisonTable,
  ChartHeaderRow,
  CompetitionName,
  ChartHeaderCell,
  EmptyHeaderCell,
  ChartBody,
  LogoImage,
  ChartHeader,
} from './styles'

const { iconOnly, iconAndText, textOnly } = entryOptions

export default function LPComparisonChart({ title, competitionName, features, subtitle }) {
  const displayFeatures = features || []
  const { skylightLogo } = defaultIcons

  const rows = displayFeatures.map((feature, idx) => {
    const {
      featureName,
      skylightFeatureEntry,
      skylightEntryIcon,
      skylightEntryIconUrl,
      skylightEntryText,
      competitionFeatureEntry,
      competitionEntryIcon,
      competitionEntryIconUrl,
      competitionEntryText,
    } = feature

    // These should help cover a scenario where the user chooses icon or text, enters data in the field for text or icon (url) and then changes their mind - ie leaving text in the text field but turning off the text option
    const useSLText = skylightFeatureEntry === textOnly || skylightFeatureEntry === iconAndText
    const useCompText =
      competitionFeatureEntry === textOnly || competitionFeatureEntry === iconAndText

    const useSLIcon = skylightFeatureEntry === iconOnly || skylightFeatureEntry === iconAndText
    const useCompIcon =
      competitionFeatureEntry === iconOnly || competitionFeatureEntry === iconAndText

    // Getting the selected URLs for the icons - icon prop values controlled through ../builderUtils/constants.js values shared with builderComponentRegistry.js
    // If 'Custom' is selected, it won't be in the defaultIcons object
    const slIconUrl = defaultIcons[skylightEntryIcon] || skylightEntryIconUrl
    const compIconUrl = defaultIcons[competitionEntryIcon] || competitionEntryIconUrl

    const hasBgColor = idx % 2 === 1
    const isLast = idx === displayFeatures.length - 1
    return (
      <LPComparisonRow
        key={`${featureName}-${idx}`}
        featureName={featureName}
        useSLText={useSLText}
        useCompText={useCompText}
        useSLIcon={useSLIcon}
        slEntryIcon={skylightEntryIcon}
        slIconUrl={slIconUrl}
        useCompIcon={useCompIcon}
        compEntryIcon={competitionEntryIcon}
        compIconUrl={compIconUrl}
        slText={skylightEntryText}
        compText={competitionEntryText}
        hasBgColor={hasBgColor}
        isLast={isLast}
      />
    )
  })

  return (
    <ChartSection>
      <Header>
        <Headline>{title}</Headline>
        {subtitle && <Subheadline>{subtitle}</Subheadline>}
      </Header>

      <ComparisonTable>
        <ChartHeader>
          <ChartHeaderRow>
            <EmptyHeaderCell> </EmptyHeaderCell>
            <ChartHeaderCell>
              <LogoImage src={skylightLogo} alt="Logo" />
            </ChartHeaderCell>
            <ChartHeaderCell>
              <CompetitionName>{competitionName}</CompetitionName>
            </ChartHeaderCell>
          </ChartHeaderRow>
        </ChartHeader>

        <ChartBody>{rows}</ChartBody>
      </ComparisonTable>
    </ChartSection>
  )
}

LPComparisonChart.propTypes = {
  title: PropTypes.string,
  competitionName: PropTypes.string,
  subtitle: PropTypes.string,
  features: PropTypes.array,
}
